import { Button, Modal } from "@deligoo/ui"
import clsx from "clsx"
import { ReactNode } from "react"
import { confirmAlert } from "react-confirm-alert"

import cls from "./ConfirmModal.module.scss"

type ConfirmModalProps = {
  title: ReactNode
  description?: string
  children?: ReactNode
  isLoading?: boolean
  contentCenter?: boolean
  autoFocusConfirm?: boolean
  handleConfirm: () => void
  handleClose: () => void
}

export const ConfirmModal = ({
  children,
  title,
  description,
  isLoading,
  contentCenter,
  autoFocusConfirm,
  handleConfirm,
  handleClose,
}: ConfirmModalProps) => {
  return (
    <Modal
      handleClose={handleClose}
      className={clsx(cls.confirmModal, contentCenter && cls.contentCenter)}
      closeBtnPosition="inside"
    >
      <div className={cls.content}>
        <div className="h300 font-weight-bold">{title}</div>
        {description && <div className="text-medium text-muted mt-5">{description}</div>}
        <form
          onSubmit={(e) => {
            e.preventDefault()
            handleConfirm()
          }}
        >
          {children && <div className="mt-5">{children}</div>}

          <div className={cls.actions}>
            <Button onClick={handleClose} color="muted" variation="outlined" disabled={isLoading}>
              Anuluj
            </Button>

            <Button color="primary" type="submit" raised loading={isLoading} autoFocus={autoFocusConfirm}>
              Potwierdź
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  )
}

/**
 * @deprecated because of bugginess - breaks rerendering cycle
 */
export function showConfirmModal({ handleConfirm, ...props }: Omit<ConfirmModalProps, "handleClose">) {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <ConfirmModal
          contentCenter
          handleConfirm={() => {
            handleConfirm()
            onClose()
          }}
          handleClose={onClose}
          {...props}
        />
      )
    },
  })
}
